// TokioBaseSettings.tsx

import { Box, Grid, MenuItem, Paper } from "@mui/material";
import * as React from "react";
import { RefObject } from "react";
import { FormHandles } from "@unform/core"; // Importando o tipo FormHandles
import { VTextField } from "../../../../../shared/forms";
import { VMaskTextField } from "../../../../../shared/forms/VMaskTextField";

interface TokioBaseSettingsProps {
	isLoading: boolean;
	coverageType: string;
	setCoverageType: (value: string) => void;
	showOutras: boolean;
	handlePredialBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
	formRef: RefObject<FormHandles>;
	onFormChange: () => void;
}

export const TokioBaseSettings: React.FC<TokioBaseSettingsProps> = ({
	isLoading,
	coverageType,
	setCoverageType,
	showOutras,
	handlePredialBlur,
	formRef,
	onFormChange,
}) => {
	const handleSelectChange = (name: string, value: string | number) => {
		formRef.current?.setFieldValue(name, value);
		onFormChange();
	};

	return (
		<Box margin={1} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0} mt={2}>
			<Grid container item direction="row" spacing={2} paddingX={2} marginBottom={2}>
				<Grid item xs={12} md={4}>
					<VMaskTextField fullWidth label="Login (Tokio)" name="user_insurance_companies" mask="text" required disabled={isLoading} />
				</Grid>
				<Grid item xs={12} md={4}>
					<VMaskTextField
						fullWidth
						label="Senha (Tokio)"
						name="password_insurance_companies"
						mask="text"
						type="password"
						required
						disabled={isLoading}
					/>
				</Grid>
				<Grid item xs={12} md={4}>
					<VMaskTextField fullWidth label="Cód. Integrador/Imob. (Tokio)" name="integrator_code" mask="text" disabled={isLoading} />
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<VTextField
						fullWidth
						label="Tipo de Repasse"
						name="transfer_type"
						select
						disabled={isLoading}
						onChange={(e) => handleSelectChange("transfer_type", e.target.value)}
					>
						<MenuItem value="broker">Corretora</MenuItem>
						<MenuItem value="insurance_company">Seguradora</MenuItem>
					</VTextField>
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<VTextField
						fullWidth
						label="Parcelas Padrão"
						name="installment_number"
						select
						disabled={isLoading}
						onChange={(e) => handleSelectChange("installment_number", e.target.value)}
					>
						{Array.from({ length: 12 }, (_, i) => (
							<MenuItem key={i + 1} value={i + 1}>
								{i + 1}x
							</MenuItem>
						))}
					</VTextField>
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<VMaskTextField fullWidth label="Comissão Corretora (%)" name="comission_broker" mask="real" inputMode="numeric" disabled={isLoading} />
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<VMaskTextField
						fullWidth
						label="Comissão Seguradora (%)"
						name="comission_insurance_companies"
						mask="real"
						inputMode="numeric"
						disabled={isLoading}
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<VTextField
						fullWidth
						label="Dia Fechamento"
						name="close_data"
						select
						disabled={isLoading}
						onChange={(e) => handleSelectChange("close_data", e.target.value)}
					>
						{Array.from({ length: 31 }, (_, i) => (
							<MenuItem key={i + 1} value={i + 1}>
								{i + 1}
							</MenuItem>
						))}
					</VTextField>
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<VTextField
						fullWidth
						label="Dia Vencimento"
						name="due_date"
						select
						disabled={isLoading}
						onChange={(e) => handleSelectChange("due_date", e.target.value)}
					>
						{Array.from({ length: 31 }, (_, i) => (
							<MenuItem key={i + 1} value={i + 1}>
								{i + 1}
							</MenuItem>
						))}
					</VTextField>
				</Grid>

				<Grid item xs={12} md={12} container spacing={2}>
					<Grid item xs={12} sm={6} md={4}>
						<VTextField
							fullWidth
							label="Tipo de Cobertura"
							name="coverageType"
							select
							value={coverageType}
							onChange={(e) => {
								setCoverageType(e.target.value);
								handleSelectChange("coverageType", e.target.value); // Notifica o VForm
							}}
							disabled={isLoading}
						>
							<MenuItem value="Predio_e_Conteudo_90_10">Prédio (90%) e Conteúdo (10%)</MenuItem>
							<MenuItem value="Predio_e_Conteudo_80_20">Prédio (80%) e Conteúdo (20%)</MenuItem>
							<MenuItem value="Predio_e_Conteudo_70_30">Prédio (70%) e Conteúdo (30%)</MenuItem>
							<MenuItem value="Predio_e_Conteudo_Outras">Prédio e Conteúdo Outras</MenuItem>
						</VTextField>
					</Grid>
					<Grid item xs={12} sm={6} md={4} sx={{ display: showOutras ? undefined : "none" }}>
						<VMaskTextField fullWidth label="Prédio (%)" name="pc_predio" mask="real" onBlur={handlePredialBlur} disabled={isLoading} />
					</Grid>
					<Grid item xs={12} sm={6} md={4} sx={{ display: showOutras ? undefined : "none" }}>
						<VMaskTextField fullWidth label="Conteúdo (%)" name="pc_conteudo" mask="real" inputProps={{ readOnly: true }} disabled={isLoading} />
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};
